import * as React from 'react';
import { mergeStyleSets, FontSizes, FontWeights } from '@fluentui/react';

import { borderStyle } from 'components/steps/commonStyles';
import { upToMediumScreenSelector } from 'utils/breakpoints';

interface TitleProps {
	content: string;
}

export const WizardTitle = ({ content }: TitleProps) => {
	return (
		<div className={styles.root}>
			<h1>{content}</h1>
		</div>
	);
};

const styles = mergeStyleSets({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		padding: '0 2rem',
		height: '4.5rem',
		borderBottom: borderStyle,
		selectors: {
			[upToMediumScreenSelector]:	{
				padding: '0 1.5rem',
				height: 'auto',
				minHeight: '4.5rem',
			}
		},
		'& h1': {
			fontSize: FontSizes.size20,
			lineHeight: FontSizes.size28,
			margin: 0,
			padding: 0,
			fontWeight: FontWeights.semibold,
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			selectors: {
				[upToMediumScreenSelector]:	{
					overflow: 'initial',
					whiteSpace: 'initial',
					textOverflow: 'initial',
					padding: '0.5rem 0'
				}
			}
		}
	}
});
